import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { OrderSearchService } from './service/order-search.service';

@Component({
    selector: 'apc-search-autocomplete',
    templateUrl: './search-autocomplete.component.html',
    styleUrls: ['./search-autocomplete.component.scss'],
    providers: [OrderSearchService],
    standalone: false
})
export class SearchAutocompleteComponent {
  @Input() showEnvWarning: boolean;
  quickSearch = new Subject<any>();
  queryString: string = '';
  searchValue: string = '';
  orders = [];
  projects = [];
  isLoading: boolean = false;
  isOpen: boolean = false;

  constructor(private readonly orderSearchService: OrderSearchService, private readonly router: Router) {
    this.quickSearch.pipe(debounceTime(1000), distinctUntilChanged()).subscribe((input) => {
      this.search(input.value);
    });
  }

  redirect(identifier: string, destination: string) {
    if (this.router.url.includes('/' + destination + '/')) {
      let url = this.router.url.split('/');
      if (url[2] === identifier) {
        let finalUrl = url.join('/');
        this.router.routeReuseStrategy.shouldReuseRoute = function () {
          return false;
        };
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([finalUrl]);
      } else {
        this.router.navigate([destination + '/' + identifier]);
      }
      
    } else {
      this.router.navigate([destination + '/' + identifier]);
    }
    this.queryString = '';
    this.searchValue = '';
    this.orders = [];
    this.projects = [];
    this.isOpen = false;
  }

  async search(value: string) {
    this.searchValue = value;
    this.queryString = this.searchValue;
    this.isLoading = true;
    this.orders = [];
    this.projects = [];
    if (this.queryString.length > 0) {
      this.orderSearchService.quickSearch(this.queryString).then(
        (res: any) => {
          this.orders = res.orders;
          this.projects = res.projects;
          this.isLoading = false;
        },
        (reason) => {
          this.isLoading = false;
        }
      );
    } else {
      this.orders = [];
      this.projects = [];
      this.isLoading = false;
    }
  }

  openSearch() {
    this.isOpen = true;
    setTimeout(() => document.getElementById('quick-search').focus(), 200);
  }

  closeSearch() {
    this.isOpen = false;
    this.orders = [];
    this.projects = [];
    this.searchValue = '';
    this.queryString = '';
  }
}
